import React from "react";
import { formatPhoneForDisplay } from "../../import/phone-format";

const RouteListCard = ({ routes = [], passengerCount = 0 }) => {
  if (!routes.length) return null;
  return (
    <section className="start-ask start-ask--quiet">
      <h3>
        {routes.length} service{routes.length === 1 ? "" : "s"} listed in this file
      </h3>
      <p className="start-muted">
        {passengerCount > 0
          ? "Passengers are placed on these by the service name in their row."
          : "No passenger rows were found, so these can only be created empty for now."}
      </p>
      <ul className="start-routes">
        {routes.slice(0, 12).map((route) => (
          <li key={route.name}>
            <strong>{route.name}</strong>
            <span>
              {[route.plate, route.driver, route.driverPhone ? formatPhoneForDisplay(route.driverPhone) : ""].filter(Boolean).join(" · ") || "—"}
            </span>
          </li>
        ))}
        {routes.length > 12 && <li className="start-muted">+{routes.length - 12} more</li>}
      </ul>
    </section>
  );
};

export default RouteListCard;
